(function () {
/**
 * FullCalendar initialization for the Event Calendar AI template.
 *
 * Expects a `#mythril-event-calendar` element with a `data-events` JSON
 * attribute. Prev/next controls live outside the calendar (carousel-style).
 * Uses month grid on desktop and list view on small screens.
 *
 * @package Mythril
 */ /* global FullCalendar */ (function($) {
    'use strict';
    /** Bootstrap md breakpoint (max-width for mobile / small screens). */ var MOBILE_MAX_WIDTH = 992;
    /**
	 * Whether the viewport should use the mobile list view.
	 *
	 * @return {boolean}
	 */ function isMobileViewport() {
        // return window.matchMedia('(max-width: ' + MOBILE_MAX_WIDTH + 'px)').matches;
        return $(window).width() <= MOBILE_MAX_WIDTH;
    }
    /**
	 * Preferred FullCalendar view for the current viewport.
	 *
	 * @return {string}
	 */ function getPreferredView() {
        return isMobileViewport() ? 'listMonth' : 'dayGridMonth';
    }
    /**
	 * Update the external month title when the calendar view changes.
	 *
	 * @param {FullCalendar.Calendar} calendar Calendar instance.
	 * @param {HTMLElement|null}      titleEl  Title element to update.
	 * @return {void}
	 */ function updateMonthTitle(calendar, titleEl) {
        if (!titleEl) return;
        titleEl.textContent = calendar.view.title;
    }
    /**
	 * Switch to the preferred view when the viewport crosses the breakpoint.
	 *
	 * @param {FullCalendar.Calendar} calendar Calendar instance.
	 * @return {void}
	 */ function syncViewToViewport(calendar) {
        var preferredView = getPreferredView();
        if (calendar.view.type !== preferredView) calendar.changeView(preferredView);
    }
    /**
	 * Initialize a single calendar instance.
	 *
	 * @param {HTMLElement} calendarEl Calendar root element.
	 * @return {void}
	 */ function initCalendar(calendarEl) {
        if (typeof FullCalendar === 'undefined' || typeof FullCalendar.Calendar !== 'function') {
            console.error('Failed to initialize calendar: FullCalendar.js is not available!');
            return;
        }
        var wrap = calendarEl.closest('.grc-module-calendar');
        var titleEl = wrap ? wrap.querySelector('[data-calendar-title]') : null;
        var prevBtn = wrap ? wrap.querySelector('[data-calendar-prev]') : null;
        var nextBtn = wrap ? wrap.querySelector('[data-calendar-next]') : null;
        var todayBtn = wrap ? wrap.querySelector('[data-calendar-today]') : null;
        // var events = getEventsFromElement(calendarEl);
        var calendar = new FullCalendar.Calendar(calendarEl, {
            initialView: getPreferredView(),
            height: 'auto',
            fixedWeekCount: false,
            showNonCurrentDates: true,
            dayMaxEvents: true,
            headerToolbar: false,
            editable: false,
            selectable: false,
            navLinks: false,
            // colorScheme: 'dark',
            borderless: true,
            className: 'grc-fc-view',
            dayRowClass: 'grc-fc-row',
            dayCellClass: 'grc-fc-day-cell',
            dayHeaderClass: 'grc-fc-day-header',
            dayHeaderRowClass: 'grc-fc-day-header-row',
            eventClass: function eventClass(args) {
                if (!args.event.start) return false;
                if (!args.event.end) return 'grc-fc-event';
                // Extract YYYY-MM-DD strings to compare calendar days safely
                var startDate = args.event.start.toISOString().split('T')[0];
                var endDate = args.event.end.toISOString().split('T')[0];
                if (startDate !== endDate) return 'grc-fc-event--multi-day';
                else return 'grc-fc-event';
            },
            listDayClass: 'grc-fc-list-day',
            eventDisplay: 'auto',
            events: {
                url: mythrilFcjsVars.ajaxUrl,
                method: 'POST',
                extraParams: {
                    action: 'get_calendar_events',
                    nonce: mythrilFcjsVars.nonce
                },
                failure: function failure() {
                    console.error('Failed to fetch events from server!');
                }
            },
            datesSet: function datesSet(info) {
                updateMonthTitle(calendar, titleEl);
                // Determine if the displayed month includes today; disable the "Today" button
                var today = new Date();
                todayBtn.disabled = today >= info.view.currentStart && today < info.view.currentEnd;
            }
        });
        calendar.render();
        updateMonthTitle(calendar, titleEl);
        if (todayBtn) todayBtn.addEventListener('click', function() {
            calendar.today();
        });
        if (prevBtn) prevBtn.addEventListener('click', function() {
            calendar.prev();
        });
        if (nextBtn) nextBtn.addEventListener('click', function() {
            calendar.next();
        });
        window.addEventListener('resize', function() {
            syncViewToViewport(calendar);
        });
    }
    document.addEventListener('DOMContentLoaded', function() {
        var calendarEl = document.getElementById('mythril-event-calendar');
        if (calendarEl) initCalendar(calendarEl);
    });
})(jQuery);

})();
//# sourceMappingURL=calendar.js.map
